import Link from 'components/shared/Link'
import Text from 'components/shared/Text'
import { FormattedMessage } from 'react-intl'
import { PRIVACY_POLICY_LINK, RODO_LINK } from 'constants/links'

const GDPRClause = () => (
    <Text variant="bodyExtraSmall" color="grayscale_700">
        <FormattedMessage
            id="global.data_administrator"
            defaultMessage="Administratorem danych osobowych jest: Global Parks Poland Sp. z o.o. z siedzibą przy ul. Fosa 41/11, 02-768 Warszawa – w przypadku założenia konta i/lub zakupu biletów w naszym parku rozrywki; Moyome Sp. z o.o. z siedzibą przy ul. Fosa 41/11, 02-768 Warszawa – w przypadku zakupu noclegu w wiosce Suntago Village. Więcej informacji na temat przetwarzania danych osobowych i przysługujących Ci prawach znajdziesz w <GDPR>klauzulach RODO</GDPR> oraz <privacyPolicy>Polityce prywatności</privacyPolicy>."
            description="Please keep the html tags in the translation"
            values={{
                GDPR: (chunks: string[]) => (
                    <Link
                        variant="secondary"
                        icon={null}
                        target="_blank"
                        path={RODO_LINK}
                        data-testid="payment-redirect-rodo"
                    >
                        <Text variant="bodyExtraSmall" as="span">
                            {chunks}
                        </Text>
                    </Link>
                ),
                privacyPolicy: (chunks: string[]) => (
                    <Link
                        variant="secondary"
                        icon={null}
                        target="_blank"
                        path={PRIVACY_POLICY_LINK}
                        data-testid="payment-redirect-privacy-policy"
                    >
                        <Text variant="bodyExtraSmall" as="span">
                            {chunks}
                        </Text>
                    </Link>
                ),
            }}
        ></FormattedMessage>
    </Text>
)

export default GDPRClause
